import type { Translations } from "./en";

export const supportedLanguages = ["en"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const rtlLanguages: SupportedLanguage[] = [];

// Dot paths to every string leaf, e.g. "ui.copyButton.copy".
type LeafPaths<T, Prefix extends string = ""> = {
  [K in keyof T & string]: T[K] extends string
    ? `${Prefix}${K}`
    : LeafPaths<T[K], `${Prefix}${K}.`>;
}[keyof T & string];

export type TranslationKey = LeafPaths<Translations>;

export type TranslationOptions = Record<string, string | number>;

// What the app injects (e.g. i18next's `t`). Wide on purpose: any string-keyed translator fits.
export type TranslationFunction = (
  key: string,
  options?: TranslationOptions,
) => string;

// What kit components call. Narrow: unknown keys fail typecheck.
export type KitTranslationFunction = (
  key: TranslationKey,
  options?: TranslationOptions,
) => string;

export const isRTL = (language: SupportedLanguage): boolean => {
  return rtlLanguages.includes(language);
};
